import styled from 'styled-components';
// @ts-ignore
import rtl from 'styled-components-rtl';
import { theme } from '@marriott/mi-ui-library-shop';

export const Styled = styled.div`
  ${rtl`
    .rfpSubmit,
    .rfpClear {
        border-radius: 0;
        min-width: 170px;
        @media ${theme.mediaQuery.mobileOnly} {
          min-width: 132px;
        }
    }
    .rfpClear {
      margin-left: 8px;
      @media ${theme.mediaQuery.tablet} {
        margin-left: 48px;
      }
    }
    body & {
      .m-input-field {
        input {
          border-radius: 0;
          border-color: #646464;
        }
        label {
          padding: 0 4px;
          left: 17px;
        }
      }
      .DayPicker-Day {
        border-radius: 0;
      }
    }
    .error-text {
      color: var(--t-form-error-color);
    }
    .dropdown-panel {
      width: 96.7% !important;
    }
    .rfp-modal-content {
      margin: auto;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      min-height: 507px;
      width: 90%;
      @media ${theme.mediaQuery.tablet} {
        width: 596px;
      }
      @media ${theme.mediaQuery.minDesktop} {
        min-height: 440px;
        width: 1000px;
      }
      &__title {
        max-width: 287px;
        @media ${theme.mediaQuery.minDesktop} {
          max-width: 620px;
        }
      }
      &--close {
        position: absolute;
        top: 30px;
        right: 30px;
        cursor: pointer;
        background: transparent;
        @media ${theme.mediaQuery.tablet} {
          top: 48px;
          right: 40px;
        }
        .icon-clear {
          font-size: 32px;
        }
      }
    }
    
  .m-input-field {
    caret-color: inherit;
    &.is-error {
      label,
      span:first-of-type {
        color: unset;
      }
      .error-text {
        color: var(--t-form-error-color) !important;
      }
    }
  }
  .error {
    label:before {
    border: 1px solid var(--t-form-error-color) !important;
    }
  }
  .col-xl-6 {
    width: 100%;
  }
`}
`;
